import { ReactNode } from "react";
import { FormattedMessage, IntlShape } from "react-intl";

import { IMPORT_STATUS } from "api/models";
import { ReactComponent as CheckIcon } from "assets/images/icons/Check.svg";
import { ReactComponent as WarningRed } from "assets/images/icons/Warning.svg";
import { ReactComponent as WarningOrange } from "assets/images/icons/WarningIcon.svg";
import { ReactComponent as ProcessingIcon } from "assets/images/icons/Processing.svg";

const getFileStatusIcon = (status: IMPORT_STATUS): ReactNode => {
  switch (status) {
    case IMPORT_STATUS.IMPORTED:
      return <CheckIcon className="file-status-icon" />;
    case IMPORT_STATUS.FAILED:
      return <WarningRed className="file-status-icon" />;
    case IMPORT_STATUS.PROCESSING:
      return <ProcessingIcon className="file-status-icon" />;
    case IMPORT_STATUS.ERRORS:
      return <WarningOrange className="file-status-icon" />;
    default:
      return null;
  }
};

const stringifyFileStatus = (status: IMPORT_STATUS, intl: IntlShape) => {
  switch (status) {
    case IMPORT_STATUS.IMPORTED:
      return intl.formatMessage({
        id: "settings.fileImportTools.fileImportHistory.imported",
        defaultMessage: "Imported",
      });
    case IMPORT_STATUS.FAILED:
      return intl.formatMessage({
        id: "settings.fileImportTools.fileImportHistory.uploadFailed",
        defaultMessage: "Upload Failed",
      });
    case IMPORT_STATUS.PROCESSING:
      return intl.formatMessage({
        id: "settings.fileImportTools.fileImportHistory.processing",
        defaultMessage: "Processing",
      });
    case IMPORT_STATUS.ERRORS:
      return intl.formatMessage({
        id: "settings.fileImportTools.fileImportHistory.hasErrors",
        defaultMessage: "Has Errors",
      });
    default:
      return "-";
  }
};

export const renderFileStatus = (status: IMPORT_STATUS, intl: IntlShape) => (
  <div className="d-flex align-items-center">
    {getFileStatusIcon(status)}
    <div className="ml-1">{stringifyFileStatus(status, intl)}</div>
  </div>
);

export const stringifyStatusDescription = (status: IMPORT_STATUS) => {
  switch (status) {
    case IMPORT_STATUS.IMPORTED:
      return (
        <FormattedMessage
          id="settings.fileImportTools.statusDescription.imported"
          defaultMessage="Data has been successfully imported to the system."
        />
      );
    case IMPORT_STATUS.FAILED:
      return (
        <FormattedMessage
          id="settings.fileImportTools.statusDescription.failed"
          defaultMessage="Failed to upload. Please re-upload the file."
        />
      );
    case IMPORT_STATUS.PROCESSING:
      return (
        <FormattedMessage
          id="settings.fileImportTools.statusDescription.pending"
          defaultMessage="Data is being uploaded/checked."
        />
      );
    case IMPORT_STATUS.ERRORS:
      return (
        <FormattedMessage
          id="settings.fileImportTools.statusDescription.errors"
          defaultMessage="Some errors were found in the data. Please review and reupload."
        />
      );
    default:
      return "-";
  }
};
